// extracted by mini-css-extract-plugin
export default {"link":"copy-link_link__2QKmH","copied":"copy-link_copied__0l1PH"};